/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToggleFeatureDirective = exports.ToggleFeatureDirective = function () {

  /* @ngInject */
  ToggleFeatureDirective.$inject = ["ToggleFeatureService"];
  function ToggleFeatureDirective(ToggleFeatureService) {
    _classCallCheck(this, ToggleFeatureDirective);

    this.restrict = 'A';

    this.ToggleFeatureService = ToggleFeatureService;
  }

  _createClass(ToggleFeatureDirective, [{
    key: 'link',
    value: function link(scope, element, attrs) {
      var feature = void 0;
      var self = this;

      scope.init = function () {
        feature = scope.$eval(attrs.toggleFeature);

        if (!angular.isObject(feature)) throw new Error('toggle-feature must be and object.');
        if (angular.isUndefined(feature.featureName)) throw new Error('featureName must be defined.');

        if (!feature.treatment) feature.treatment = '';

        // Get updates
        if (angular.isDefined(feature.callback)) self.ToggleFeatureService.onTreatmentUpdate(feature.featureName, feature.callback, feature.user);
        self.ToggleFeatureService.onTreatmentUpdate(feature.featureName, scope.getTreatment, feature.user);
      };
      // Get Treatment
      scope.getTreatment = function (featureTreatment) {
        feature.treatment = featureTreatment;
      };
      scope.$on('$destroy', function () {
        if (angular.isDefined(feature.callback)) self.ToggleFeatureService.removeCallback(feature.callback);
        self.ToggleFeatureService.removeCallback(scope.getTreatment);
      });
      scope.init();
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory(ToggleFeatureService) {
      ToggleFeatureDirective.instance = new ToggleFeatureDirective(ToggleFeatureService);
      return ToggleFeatureDirective.instance;
    }
  }]);

  return ToggleFeatureDirective;
}();

/***/ },
/* 1 */
/***/ function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToggleFeatureService = exports.ToggleFeatureService = function () {

  /* @ngInject */
  ToggleFeatureService.$inject = ["$q", "$log", "$http", "ToggleFeature"];
  function ToggleFeatureService($q, $log, $http, ToggleFeature) {
    _classCallCheck(this, ToggleFeatureService);

    this.$q = $q;
    this.$log = $log;
    this.ToggleFeature = ToggleFeature;
    this.numberErrors = 0;
    this.$http = $http;
  }

  _createClass(ToggleFeatureService, [{
    key: 'getBasePath',
    value: function getBasePath() {
      if (!this.ToggleFeature.isEnvironment(this.ToggleFeature.config.env)) {
        this.$log.warn('Env: ' + this.ToggleFeature.config.env + ' not supported, default to development');
        this.ToggleFeature.config.env = 'development';
      }

      return this.ToggleFeature.config.paths[this.ToggleFeature.config.env];
    }

    // Returns $http config object

  }, {
    key: 'getHeaders',
    value: function getHeaders() {
      var config = {};

      if (this.ToggleFeature.config.api_key) {
        // header for this request only, does not overwrite common headers
        var headers = angular.copy(this.$http.defaults.headers.common);
        headers['Authorization'] = 'Basic ' + this.ToggleFeature.config.api_key;
        config.headers = headers;
      } else {
        // use default headers
        config.headers = this.$http.defaults.headers.common;
      }

      return config;
    }
  }, {
    key: 'getTreatment',
    value: function getTreatment(featureName) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.ToggleFeature.user) throw new Error('user must be defined.');
      if (angular.isUndefined(this.ToggleFeature.user.key)) throw new Error('user.key must be defined.');
      if (!angular.isString(featureName)) throw new Error('featureName must be a string.');

      user = user || this.ToggleFeature.user;

      var data = {
        feature: featureName,
        attributes: user.attributes || user
      };

      return this.$http.post(this.getBasePath() + '/treatment/' + encodeURIComponent(user.key), data, this.getHeaders()).then(function (response) {
        return response.data.feature;
      });
    }
  }, {
    key: 'getTreatments',
    value: function getTreatments(features, user) {
      if (!angular.isArray(features)) throw new Error('features must be and array');
      if (angular.isUndefined(user)) throw new Error('user must be defined');
      features = features.map(function (feature) {
        if (!angular.isString(feature)) throw new Error('features must be an array of string');
        return feature;
      });

      var data = {
        features: features,
        attributes: user.attributes || user
      };

      return this.$http.post(this.getBasePath() + '/treatments/' + encodeURIComponent(user.key), data, this.getHeaders()).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'onTreatmentUpdate',
    value: function onTreatmentUpdate(featureName, onUpdate) {
      var _this = this;

      var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!angular.isString(featureName)) throw new Error('featureName must be a string.');
      if (!angular.isFunction(onUpdate)) throw new Error('onUpdate must be a function.');

      if (!this.callbacks) this.callbacks = [];

      var index = this.callbacks.findIndex(function (item) {
        return item.callback === onUpdate;
      });

      if (index === -1) {
        this.callbacks.push({
          feature: featureName,
          callback: onUpdate,
          user: user
        });

        // start interval
        this.onCallbacksInterval().then(function (treatments) {
          _this.emitTreatments(treatments);
        }).catch(function (err) {
          _this.waitForUpdate();
        });
      }
    }
  }, {
    key: 'removeCallback',
    value: function removeCallback(onUpdate) {
      if (!angular.isFunction(onUpdate)) throw new Error('onUpdate must be a function.');
      if (!this.callbacks) return;
      if (this.callbacks.length === 0) return;

      var index = this.callbacks.findIndex(function (item) {
        return item.callback === onUpdate;
      });

      if (index !== -1) {
        this.callbacks.splice(index, 1);
      }
    }
  }, {
    key: 'waitForUpdate',
    value: function waitForUpdate() {
      var _this2 = this;

      if (angular.isDefined(this.canceller)) this.canceller.resolve('aborted');

      this.canceller = this.$q.defer();
      var aborted = false;

      var url = this.getBasePath() + '/treatments/updates';

      var startTime = new Date().getTime();
      this.$http.get(url, angular.merge({ timeout: this.canceller.promise }, this.getHeaders())).then(function (response) {
        return _this2.onCallbacksInterval();
      }).then(function (treatments) {
        _this2.emitTreatments(treatments);
      }).catch(function (err) {
        aborted = err.config.timeout['$$state'].value === 'aborted';
        var respTime = new Date().getTime() - startTime;
        if (respTime < _this2.ToggleFeature.config.update_rate && err.status !== 504 && !aborted) _this2.numberErrors++;
      }).finally(function () {
        if (!aborted) {
          if (_this2.numberErrors < _this2.ToggleFeature.config.max_number_errors) _this2.waitForUpdate();else _this2.$log.warn('Stopping waiting for updates, too many errors fired.');
        }
      });
    }
  }, {
    key: 'onCallbacksInterval',
    value: function onCallbacksInterval() {
      var _this3 = this;

      if (!this.callbacks) return;
      this.grouped = [];

      this.callbacks.forEach(function (item) {
        var user = item.user || _this3.ToggleFeature.user;
        var index = _this3.grouped.findIndex(function (group) {
          return group.user.key === user.key;
        });
        if (index === -1) {
          _this3.grouped.push({
            user: user,
            features: [item.feature],
            callbacks: [item.callback]
          });
        } else {
          _this3.grouped[index].features.push(item.feature);
          _this3.grouped[index].callbacks.push(item.callback);
        }
      });

      var promises = this.grouped.map(function (item) {
        return _this3.getTreatments(item.features, item.user).catch(function (err) {
          _this3.$log.error('ERROR: ' + _this3.getBasePath() + ' is unavaiable', err);
        });
      });

      return this.$q.all(promises);
    }
  }, {
    key: 'emitTreatments',
    value: function emitTreatments(treatments) {
      for (var indexGroup in this.grouped) {
        var group = this.grouped[indexGroup];
        for (var indexCallback in group.callbacks) {
          var callback = group.callbacks[indexCallback];
          var treatment = treatments[indexGroup].treatments[group.features[indexCallback]];
          callback(treatment);
        }
      }

      this.waitForUpdate();
    }
  }]);

  return ToggleFeatureService;
}();

var ToggleFeature = exports.ToggleFeature = function () {

  /* @ngInject */
  ToggleFeature.$inject = ["KUNAN_DEFAULT_PATHS", "KUNAN_DEFAULT_UPDATE_RATE", "KUNAN_DEFAULT_MAX_NUMBER_ERRORS"];
  function ToggleFeature(KUNAN_DEFAULT_PATHS, KUNAN_DEFAULT_UPDATE_RATE, KUNAN_DEFAULT_MAX_NUMBER_ERRORS) {
    _classCallCheck(this, ToggleFeature);

    this.$log = angular.injector(['ng']).get('$log');
    this.user = null;
    this.envs = ['development', 'staging', 'production'];
    this.config = {
      paths: KUNAN_DEFAULT_PATHS,
      update_rate: KUNAN_DEFAULT_UPDATE_RATE,
      max_number_errors: KUNAN_DEFAULT_MAX_NUMBER_ERRORS,
      env: this.envs[0]
    };
  }

  _createClass(ToggleFeature, [{
    key: 'setConfig',
    value: function setConfig(config) {
      if (angular.isUndefined(config)) throw new Error('config must be defined');
      if (!angular.isObject(config)) throw new Error('config must be and object');

      if (angular.isDefined(config.paths)) {
        if (!angular.isObject(config.paths)) throw new Error('config.paths must be an object');
        if (angular.isString(config.paths.development)) this.config.paths.development = config.paths.development;
        if (angular.isString(config.paths.staging)) this.config.paths.staging = config.paths.staging;
        if (angular.isString(config.paths.production)) this.config.paths.production = config.paths.production;
      }
      if (angular.isDefined(config.update_rate)) {
        if (!angular.isNumber(config.update_rate)) throw new Error('config.update_rate must be a number');
        if (config.update_rate < 10000) this.$log.warn(config.update_rate + ' miliseconds is too low');
        this.config.paths = config.paths;
      }
      if (angular.isDefined(config.max_number_errors)) {
        if (!angular.isNumber(config.max_number_errors)) throw new Error('config.max_number_errors must be a number');
        this.config.paths = config.paths;
      }
      if (angular.isDefined(config.env)) {
        if (!angular.isString(config.env)) throw new Error('config.env must be an string.');
        if (this.isEnvironment(config.env)) {
          this.config.env = config.env;
        } else {
          this.config.env = this.envs[0]; // development
          this.$log.warn('Env: ' + config.env + ' not supported, default to ' + this.config.env);
        }
      }

      if (angular.isDefined(config.api_key)) {
        if (!angular.isString(config.api_key)) throw new Error('config.api_key must be a string.');
        this.config.api_key = config.api_key;
      }
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: 'setUser',
    value: function setUser(user) {
      if (!angular.isObject(user)) throw new Error('user must be an object.');
      this.user = user;
    }
  }, {
    key: 'getUser',
    value: function getUser() {
      return this.user;
    }
  }, {
    key: 'isEnvironment',
    value: function isEnvironment(env) {
      return this.envs.indexOf(env.toLowerCase()) > -1;
    }
  }, {
    key: '$get',
    value: function $get() {
      var self = this;
      return {
        get user() {
          return self.getUser();
        },
        set user(user) {
          return self.setUser(user);
        },
        get config() {
          return self.getConfig();
        },
        set config(config) {
          return self.setConfig(config);
        },
        isEnvironment: function isEnvironment(env) {
          return self.isEnvironment(env);
        }
      };
    }
  }]);

  return ToggleFeature;
}();

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleFeature = __webpack_require__(0);

var _toggleFeature2 = __webpack_require__(1);

var moduleName = 'MW.ToggleFeature';

angular.module(moduleName, []).provider('ToggleFeature', _toggleFeature2.ToggleFeature).service('ToggleFeatureService', _toggleFeature2.ToggleFeatureService).directive('toggleFeature', ["ToggleFeatureService", _toggleFeature.ToggleFeatureDirective.directiveFactory]).constant('KUNAN_DEFAULT_UPDATE_RATE', 30000).constant('KUNAN_DEFAULT_MAX_NUMBER_ERRORS', 20).constant('KUNAN_DEFAULT_PATHS', {
  development: 'https://v1.toggle.dev.kunan.meltwater.io',
  staging: 'https://v1.toggle.staging.kunan.meltwater.io',
  production: 'https://v1.toggle.kunan.meltwater.io'
});

exports.default = moduleName;

/***/ }
/******/ ]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@meltwater/gaf-toggle-feature/dist/toggleFeature.js
 ** module id = 150
 ** module chunks = 0 1
 **/